import { useEffect, useState } from "react";
import { COLORS, Ic, ICONS, iconForKey } from "@/lib/theme";
import { apiGet } from "@/lib/api";
import BackHomeBar from "@/components/BackHomeBar";

import { isPhoneApp } from "@/lib/phoneApp";

const phoneSections = ["LinkShul", "Saltzman Community Centre", "Mikvah Rachel", "LinksYouth", "Chesed Committee", "Links Gentry", "Learning and Tehillim Groups", "Our Team"];

export default function Community({ onOpenDetail, onHome }) {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    apiGet("/community").then((d) => setSections(d.sections || [])).catch(() => {});
  }, []);

  return (
    <div className="ls-scroll" data-testid="community-screen" style={{ paddingBottom: 100 }}>
      <BackHomeBar title="Community" onHome={onHome} />
      <div style={{ padding: "26px 22px 0" }}>
        <div className="font-heading" style={{ fontWeight: 800, fontSize: 26, color: COLORS.ink }}>Our Community</div>
        <div style={{ color: COLORS.muted, fontWeight: 600, fontSize: 13, marginTop: 4 }}>United, empowered & innovative</div>
      </div>
      <div style={{ padding: "16px 18px 0" }}>
        {isPhoneApp && <><p>For more information, contact the Shul office or a committee member at <a href="mailto:admin@linkshul.co.za">admin@linkshul.co.za</a>.</p>{phoneSections.map((title) => <div key={title} className="ls-card" style={{ padding: 16, marginBottom: 12, fontWeight: 800 }}>{title}</div>)}</>}
        {!isPhoneApp && sections.map((s) => (
          <div
            key={s.id}
            data-testid={`community-${s.id}`}
            onClick={() => onOpenDetail({ title: s.title, body: "community", section: s })}
            className="ls-card no-tap-highlight"
            style={{ padding: 16, marginBottom: 12, display: "flex", gap: 14, alignItems: "center", cursor: "pointer" }}
          >
            <div style={{ width: 48, height: 48, borderRadius: 14, background: COLORS.lilac, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Ic d={iconForKey(s.icon)} color={COLORS.plum} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 800, fontSize: 15 }}>{s.title}</div>
              <div style={{ fontSize: 12.5, color: COLORS.muted, fontWeight: 600, lineHeight: 1.35, marginTop: 2 }}>
                {s.short}
              </div>
            </div>
            <Ic d={ICONS.arrow} color="#c3b6cd" size={20} />
          </div>
        ))}
      </div>
    </div>
  );
}
